import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './schoolvisit.css';
import { FaSchool, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCalendarAlt, FaChild } from 'react-icons/fa';

function SchoolVisit() {
  const [formData, setFormData] = useState({
    schoolName: '',
    contactPerson: '',
    phoneNumber: '',
    email: '',
    address: '',
    studentCount: '',
    preferredDate: '',
    additionalInfo: ''
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Add a new document to the 'schoolrequest' collection
      await addDoc(collection(db, 'schoolrequest'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'pending' // You can add additional fields like status
      });
      
      setSubmissionStatus('success');
      // Reset form after successful submission
      setFormData({
        schoolName: '',
        contactPerson: '',
        phoneNumber: '',
        email: '',
        address: '',
        studentCount: '',
        preferredDate: '',
        additionalInfo: ''
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      setSubmissionStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="school-visit-container">
      <section className="visit-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1><FaSchool className="hero-icon" /> Request a School Visit</h1>
          <p className="hero-tagline">Bring our eye checkup camp to your institution</p>
        </div>
      </section>

      <section className="visit-form-section">
        <div className="form-container">
          <h2><FaSchool /> School Information</h2>
          <p>Fill out the form below to request an eye checkup camp at your school. Our team will contact you to schedule the visit.</p>
          
          {submissionStatus === 'success' && (
            <div className="success-message">
              <p>Thank you for your request! We've received your information and will contact you shortly to schedule the visit.</p>
            </div>
          )}

          {submissionStatus === 'error' && (
            <div className="error-message">
              <p>There was an error submitting your request. Please try again or contact us directly.</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="school-visit-form">
            <div className="form-group">
              <label htmlFor="schoolName">
                <FaSchool className="input-icon" /> School Name
              </label>
              <input
                type="text"
                id="schoolName"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="contactPerson">
                <FaUser className="input-icon" /> Contact Person
              </label>
              <input
                type="text"
                id="contactPerson"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phoneNumber">
                <FaPhone className="input-icon" /> Phone Number
              </label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">
                <FaEnvelope className="input-icon" /> Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="address">
                <FaMapMarkerAlt className="input-icon" /> School Address
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="studentCount">
                <FaChild className="input-icon" /> Approximate Number of Students
              </label>
              <input
                type="number"
                id="studentCount"
                name="studentCount"
                value={formData.studentCount}
                onChange={handleChange}
                required
                min="1"
              />
            </div>

            <div className="form-group">
              <label htmlFor="preferredDate">
                <FaCalendarAlt className="input-icon" /> Preferred Date (if any)
              </label>
              <input
                type="date"
                id="preferredDate"
                name="preferredDate"
                value={formData.preferredDate}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="additionalInfo">Additional Information</label>
              <textarea
                id="additionalInfo"
                name="additionalInfo"
                value={formData.additionalInfo}
                onChange={handleChange}
                placeholder="Any special requirements or information we should know"
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>
        </div>

        <div className="visit-info">
          <h3>What happens after you submit?</h3>
          <div className="info-step">
            <div className="step-number">1</div>
            <p>Our team will review your request within 2 business days</p>
          </div>
          <div className="info-step">
            <div className="step-number">2</div>
            <p>We'll contact you to discuss details and schedule the visit</p>
          </div>
          <div className="info-step">
            <div className="step-number">3</div>
            <p>We'll provide all necessary preparation guidelines</p>
          </div>
          <div className="info-step">
            <div className="step-number">4</div>
            <p>Our team will arrive on the scheduled date with all equipment</p>
          </div>

          <div className="contact-info-box">
            <h3>Have questions?</h3>
            <p><FaPhone /> +94 11 7 700904</p>
            <p><FaEnvelope /> communityeyecare@gmail.com</p>
            <p><FaMapMarkerAlt /> No: 674/8, Maradana Road,Colombo 10</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SchoolVisit;